module.exports = __webpack_public_path__ + "img/index_cover.6f53a848.svg";